(function(factory) {
    if ( typeof define === 'function' && define.amd) {
        // using AMD; register as anon module
        define('mmc.libs.jquery.mmcFormDefaults',['jquery'], factory);
    } else {
        // no AMD; invoke directly
        factory(jQuery);
    }
}(function($) {
    $.fn.mmcFormDefaults = function() {
        function supports_input_placeholder() {
            var i = document.createElement('input');
            return 'placeholder' in i;
        }

        if (!supports_input_placeholder()) {
            this.each(function() {
                if ($(this).val() === '') {
                    $(this).val($(this).attr('placeholder')).addClass('empty');
                }
                $(this).bind('focus', function() {
                    if ($(this).val() === $(this).attr('placeholder') || $(this).val() === '') {
                        $(this).val('').removeClass('empty');
                    }
                });
                $(this).bind('blur', function() {
                    if ($(this).val() === '') {
                        $(this).val($(this).attr('placeholder')).addClass('empty');
                    }
                });
            });
        }
        return this;
    };
}));
